"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HedgeRateFormatError = exports.HEDGE_RATE_MAX_SCALE = void 0;
exports.toHedgeRate = toHedgeRate;
exports.convertAtRate = convertAtRate;
const money_1 = require("./money");
exports.HEDGE_RATE_MAX_SCALE = 12;
class HedgeRateFormatError extends Error {
    constructor(value) {
        super(`Not a hedge rate: ${JSON.stringify(value)}`);
        this.name = 'HedgeRateFormatError';
    }
}
exports.HedgeRateFormatError = HedgeRateFormatError;
const HEDGE_RATE_PATTERN = /^([+-]?)(\d*)(?:\.(\d*))?$/;
function parseHedgeRate(value) {
    const trimmed = value.trim();
    const match = HEDGE_RATE_PATTERN.exec(trimmed);
    if (match === null)
        throw new HedgeRateFormatError(value);
    const [, sign = '', intDigits = '', fracDigits = ''] = match;
    if (intDigits.length === 0 && fracDigits.length === 0)
        throw new HedgeRateFormatError(value);
    // A rate carries whatever precision the source trade quoted it at; trimming it would silently
    // change the number, so a rate past twelve fraction digits is refused rather than rounded.
    if (fracDigits.length > exports.HEDGE_RATE_MAX_SCALE)
        throw new HedgeRateFormatError(value);
    const magnitude = BigInt(`${intDigits}${fracDigits}` || '0');
    return { units: sign === '-' ? -magnitude : magnitude, scale: fracDigits.length };
}
function unitsOfMoney(value) {
    const negative = value.startsWith('-');
    const unsigned = negative ? value.slice(1) : value;
    const magnitude = BigInt(unsigned.split('.').join(''));
    return { units: negative ? -magnitude : magnitude, scale: money_1.MONEY_SCALE };
}
function formatExact(units, scale) {
    const negative = units < 0n;
    const magnitude = negative ? -units : units;
    if (scale === 0)
        return `${negative ? '-' : ''}${magnitude.toString()}`;
    const digits = magnitude.toString().padStart(scale + 1, '0');
    const cut = digits.length - scale;
    return `${negative ? '-' : ''}${digits.slice(0, cut)}.${digits.slice(cut)}`;
}
function toHedgeRate(value) {
    const { units } = parseHedgeRate(value);
    if (units <= 0n)
        throw new HedgeRateFormatError(value);
    return value.trim();
}
function convertAtRate(amount, rate) {
    const amountUnits = unitsOfMoney(amount);
    const rateUnits = parseHedgeRate(rate);
    const productUnits = amountUnits.units * rateUnits.units;
    const productScale = amountUnits.scale + rateUnits.scale;
    return (0, money_1.toMoney)(formatExact(productUnits, productScale));
}
//# sourceMappingURL=hedge-rate.js.map